module.exports = __webpack_public_path__ + "img/venetian_crossroads_2k.0d210507.png";